import { mapActions, mapMutations } from 'vuex';
import ViewOnlyJsonViewer from '@/components/ViewOnlyJsonViewer.vue';

const mailMetaMixin = {
	components: {
		ViewOnlyJsonViewer,
	},
	mounted() {
		// console.log("this.selectedFile", this.selectedFile)
		this.tabItems.push({
			name: 'Mail Meta',
			tabId: 'tab-10',
			component: 'ViewOnlyJsonViewer',
			props: {
				JSONInfo: this.selectedFile || {},
			},
		});
	},
};

export default mailMetaMixin;
